import * as React from 'react';

export const header = {
  heading: 'How Do We Collect Information?'
};
export const richText1 = {
  id: 'CollectInformation',
  html:
    '                <p>We collect information directly from you.</p>\n'
    + '                <p><br/></p>\n'
    + '                <p>For example, we collect information when you: </p>\n'
    + '                <ul>\n'
    + '                  <li>Visit our stores or other facilities </li>\n'
    + '                  <li>Register for an account or complete a survey  </li>\n'
    + '                  <li>Make an online or in-store purchase </li>\n'
    + '                  <li>Use an online forum, submit a question or answer to our Product Q & A, \n'
    + '                      provide us with comments or reviews, or contact our call centers </li>\n'
    + '                  <li>Upload or share a photo, submit a request, submit information, or post   \n'
    + '                      other digital content through one of our websites, applications or via social media'
    + '                      interactions on third party websites like Facebook, Instagram, Pinterest or Twitter</li>\n'
    + '                  <li>Register for one of our programs or offers, or apply for a The Home Depot \n'
    + '                      credit card or a home improvement loan </li>'
    + '                  <li>Participate in a sweepstakes, contest, promotion, program, clinic, or workshop </li>\n'
    + '                  <li>Rent equipment or vehicles or request a quote, warranty, or other information</li>\n'
    + '                  <li>Return a product or use a rebate</li>\n'
    + '                  <li>Request we send you an electronic copy of your in-store receipt </li>\n'
    + '                  <li>Apply or inquire about employment </li>\n'
    + '                  <li>Submit information via our websites, mobile websites, or applications </li>\n'
    + '                 </ul>\n'
    + '                <p><br/></p>\n'
    + '                <p>We collect information from you passively. </p>\n'
    + '                <p>We use tools like browser cookies, flash cookies, pixel tags, and web beacons\n'
    + '                to collect information when you use our websites and applications or interact\n'
    + '                with our emails. For more information about these tools and the choices you may have,\n'
    + '                please read the <a href="#TrackingTools">Our Tracking Tools</a> section.  And we use cameras and other technologies\n'
    + '                in our stores, in parking lots and at other facilities to learn about customer traffic\n'
    + '                and for fraud prevention, security, and asset protection </p>\n'
    + '                <p><br/></p>\n'
    + '                <p>We collect information from Affiliates of The Home Depot.</p> \n'
    + '                <p>We may receive information about you from companies that are controlled by or under \n'
    + '                   common control with The Home Depot (our “Affiliates”).</p> \n'
    + '                <p><br/></p>\n'
    + '                <p> We collect information from third parties. </p> \n'
    + '                <p>In the course of serving you and operating our business, we collect information \n'
    + '                   from a variety of third parties. For example, we collect information from: </p>\n'
    + '                <ul> \n'
    + '                  <li>Shipping companies </li>\n'
    + '                  <li>Installers </li>\n'
    + '                  <li>Subscription providers </li>\n'
    + '                  <li>Your friends and contacts </li>\n'
    + '                  <li>Marketing companies that help us learn about consumer interests and trends </li>\n'
    + '                  <li>Companies that supplement our customer records with additional information </li>\n'
    + '                  <li>Online advertising and analytics providers </li>\n'
    + '                  <li>Social media platforms </li>\n'
    + '                  <li>Mailing vendors </li>\n'
    + '                  <li>Public records resources </li>\n'
    + '                  <li>Suppliers of property information </li>\n'
    + '                  <li>Companies that help us process payments </li>\n'
    + '                  <li>Service providers that operate on our behalf and collect information </li>\n'
    + '                  <li>Financial institutions and other companies that help provide or support financial products and offers </li>\n'
    + '                  <li>Security and fraud prevention providers </li>\n'
    + '                  <li>Manufacturers and other businesses with which we conduct joint offers or programs </li>\n'
    + '                 </ul>\n'
};
